export const imgUrl = import.meta.env.VITE_IMAGE_URL;
export const url = import.meta.env.VITE_BASE_URL;
export const editorUrl = import.meta.env.VITE_ADSIGN_EDITOR_URL;
